module.exports = __webpack_public_path__ + "static/media/Link-Icon.7bad56f5.svg";